/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/search/search.resolver.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable } from "@angular/core";
import { SearchRequestTokenKind, VisionIcsApiService, } from "vics/visionics/api/ng/index";
import * as i0 from "@angular/core";
import * as i1 from "vics/visionics/api/ng/index";
export class SearchResultsResolver {
    /**
     * @param {?} api
     */
    constructor(api) {
        this.api = api;
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    resolve(route, state) {
        /** @type {?} */
        const query = route.queryParamMap.get('q');
        return this.api.search({
            tokens: query.split(" ").map((/**
             * @param {?} value
             * @return {?}
             */
            value => ({
                kind: SearchRequestTokenKind.NAME,
                value,
            }))),
        });
    }
}
SearchResultsResolver.decorators = [
    { type: Injectable, args: [{ providedIn: "root" },] },
];
/** @nocollapse */
SearchResultsResolver.ctorParameters = () => [
    { type: VisionIcsApiService }
];
/** @nocollapse */ SearchResultsResolver.ɵfac = function SearchResultsResolver_Factory(t) { return new (t || SearchResultsResolver)(i0.ɵɵinject(i1.VisionIcsApiService)); };
/** @nocollapse */ SearchResultsResolver.ɵprov = i0.ɵɵdefineInjectable({ token: SearchResultsResolver, factory: SearchResultsResolver.ɵfac, providedIn: "root" });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SearchResultsResolver, [{
        type: Injectable,
        args: [{ providedIn: "root" }]
    }], function () { return [{ type: i1.VisionIcsApiService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    SearchResultsResolver.prototype.api;
}
//# sourceMappingURL=data:application/json;base64,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